import { Layout } from 'components/Layout'
import { ArcPageShell } from 'components/ArcPageShell'
import { CurrentUserContextProvider } from 'context/useCurrentUser'
import { NotificationProvider } from 'context'
import { SchoolDetailsForm } from './components/SchoolDetailsForm'

function SchoolDetailsView() {
  return (
    <Layout>
      <ArcPageShell title='School details' backTo='/teacher/settings' backLabel='Back to school settings'>
        <SchoolDetailsForm />
      </ArcPageShell>
    </Layout>
  )
}

export function SchoolDetailsPage() {
  return (
    <CurrentUserContextProvider>
      <NotificationProvider>
        <SchoolDetailsView />
      </NotificationProvider>
    </CurrentUserContextProvider>
  )
}
